import api from './api';

export const adminService = {
  async createClient(clientData) {
    const response = await api.post('/admin/clients', clientData);
    return response.data;
  },

  async getClients() {
    const response = await api.get('/admin/clients');
    return response.data;
  },

  async createDepartment(deptData) {
    const response = await api.post('/admin/departments', deptData);
    return response.data;
  },

  async getDepartments() {
    const response = await api.get('/admin/departments');
    return response.data;
  },

  async createCategory(categoryData) {
    const response = await api.post('/admin/categories', categoryData);
    return response.data;
  },

  async getCategories() {
    const response = await api.get('/admin/categories');
    return response.data;
  },

  async createUser(userData) {
    const response = await api.post('/users', userData);
    return response.data;
  },

  async getAllUsers() {
    const response = await api.get('/users');
    return response.data;
  },

  async updateUser(userId, userData) {
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  },

  async deleteUser(userId) {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  },

  async assignManager(userId, managerId) {
    const response = await api.put(`/admin/users/${userId}/assign-manager`, {
      managerId
    });
    return response.data;
  },

  async deleteClient(clientId) {
    const response = await api.delete(`/admin/clients/${clientId}`);
    return response.data;
  },

  async updateClient(clientId, payload) {
    const response = await api.put(`/admin/clients/${clientId}`, payload);
    return response.data;
  },

  async deleteDepartment(departmentId) {
    const response = await api.delete(`/admin/departments/${departmentId}`);
    return response.data;
  },

  async updateDepartment(departmentId, payload) {
    const response = await api.put(`/admin/departments/${departmentId}`, payload);
    return response.data;
  },

  async deleteCategory(categoryId) {
    const response = await api.delete(`/admin/categories/${categoryId}`);
    return response.data;
  },

  async updateCategory(categoryId, payload) {
    const response = await api.put(`/admin/categories/${categoryId}`, payload);
    return response.data;
  }
};
